// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconSticker = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 51.8131V51.8439C24.0014 53.5117 22.6722 54.4376 21.1333 53.7945C12.834 50.326 8 42.7352 8 32C8 17.191 17.191 8 32 8C42.7352 8 50.3259 12.8339 53.7945 21.1332C54.4376 22.6721 53.5117 24.0013 51.8439 23.9999H51.8132C34.8039 23.9999 24 34.8033 24 51.8131ZM51.9163 27.9999H51.8959C37.1511 27.9999 27.9999 37.1511 27.9999 51.8959V51.9162C28.0013 53.8867 30.1755 54.6989 31.5803 53.2941L53.2941 31.5802C54.6987 30.1755 53.8871 28.0012 51.9163 27.9999Z" />
    </svg>
  );
};
